export const internationalPhoneNumber = `+441952456850`
export const localPhoneNumber = `01952456850`
export const internationalPhoneNumberReadable = `+44 1952 456 850`
export const localPhoneNumberReadable = `01952 456 850`
